<template>
  <div class="item">
    <div class="item-top">
      <span class="goodsName">{{ item.skuCode }} {{ item.goodsName || '-' }}</span>
      <span @click="deleteShoppingCartGood" class="del-btn">删除</span>
    </div>
    <div class="item-bottom">
      <div>
        <img width="77px" :src="item.fileUrls" />
      </div>
      <div class="item-right">
        <div class="text" v-if="type===1">型号：{{ item.model }}</div>
        <div class="text" v-if="type===4">型号/规格：{{ item.model }}/{{ item.oldSpecification }}</div>
        <div class="text">包装规格：起订量{{ item.moq || 1 }}{{ item.sellingUnit}}，步长{{ item.sellingUnitStepSize || 1 }}{{ item.sellingUnit}}</div>
        <div class="set-num">
          <div class="text">
            单价：
            <span class="price" v-if="type===1">{{ item.sellingPrice | formatePrice }}</span>
            <span class="price" v-if="type===4">{{ item.sellingPrice | formatePrice4 }}</span>
          </div>
          <el-input-number
            v-model="goodsNum"
            @change="handleChangeCount"
            :min="1"
            :max="999999999"
            :step="item.sellingUnitStepSize || 1"
            :precision="0"
            size="mini"
          ></el-input-number>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dataListLoading: false,
      goodsNum: 0
    }
  },
  watch: {
    item: {
      handler () {
        this.goodsNum = this.item.goodsNum || 0
      },
      immediate: true
    }
  },
  methods: {
    // 更改购物车数量
    handleChangeCount () {
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http
        .post(`/front/consumer/shoppingcart/updateShoppingCart`, {
          shoppingCartId: this.item.shoppingCartId,
          goodsNum: this.goodsNum
        })
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code === 0) {
            this.$emit('change')
            return
          }
          this.goodsNum = this.item.goodsNum || 0
        })
    },
    // 删除购物车信息
    deleteShoppingCartGood () {
      this.$http
        .post(`/front/consumer/shoppingcart/deleteShoppingCart`, [
          this.item.shoppingCartId
        ])
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$emit('change')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  background: #ffffff;
  border-radius: 10px;
  margin-top: 12px;
  padding: 12px;
  &:first-child {
    margin-top: 0;
  }
}

.item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .goodsName {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    line-height: 20px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .del-btn {
    font-size: 12px;
    color: #f81b1b;
    line-height: 17px;
    cursor: pointer;
  }
}

.item-bottom {
  display: flex;
  padding-top: 8px;
  .item-right {
    padding-left: 8px;
    flex: 1;
  }
  .text {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    padding-bottom: 8px;
  }
}

.price {
  &::before {
    content: '¥';
    font-size: 12px;
  }
  color: #f62f18;
}

.set-num {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    padding: 0;
  }
}
</style>
